// Cookie utility functions
export const cookieUtils = {
  // Set a cookie with expiration
  setCookie(name, value, days = 30) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = `expires=${date.toUTCString()}`
    document.cookie = `${name}=${value};${expires};path=/`
  },

  // Get a cookie value
  getCookie(name) {
    const nameEQ = `${name}=`
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i]
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1)
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length)
      }
    }
    return null
  },

  // Delete a cookie
  deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
  },

  // Get favorite teams from cookie
  getFavoriteTeams() {
    const favorites = this.getCookie('cfb_favorite_teams')
    return favorites ? JSON.parse(favorites) : []
  },

  // Add a team to favorites
  addFavoriteTeam(teamId, teamName) {
    const favorites = this.getFavoriteTeams()
    const existingIndex = favorites.findIndex(team => team.id === teamId)
    
    if (existingIndex === -1) {
      favorites.push({ id: teamId, name: teamName })
      this.setCookie('cfb_favorite_teams', JSON.stringify(favorites))
      return true
    }
    return false
  },

  // Remove a team from favorites
  removeFavoriteTeam(teamId) {
    const favorites = this.getFavoriteTeams()
    const filteredFavorites = favorites.filter(team => team.id !== teamId)
    this.setCookie('cfb_favorite_teams', JSON.stringify(filteredFavorites))
    return filteredFavorites.length !== favorites.length
  },

  // Check if a team is in favorites
  isFavoriteTeam(teamId) {
    const favorites = this.getFavoriteTeams()
    return favorites.some(team => team.id === teamId)
  },

  // Get notification settings from cookie
  getNotificationSettings() {
    const settings = this.getCookie('cfb_notification_settings')
    return settings ? JSON.parse(settings) : {}
  },

  // Save notification settings to cookie
  saveNotificationSettings(settings) {
    this.setCookie('cfb_notification_settings', JSON.stringify(settings))
  },

  // Get a specific notification setting
  getNotificationSetting(key, defaultValue = false) {
    const settings = this.getNotificationSettings()
    return settings[key] !== undefined ? settings[key] : defaultValue
  },

  // Set a specific notification setting
  setNotificationSetting(key, value) {
    const settings = this.getNotificationSettings()
    settings[key] = value
    this.saveNotificationSettings(settings)
  },

  // Get timezone settings from cookie
  getTimezoneSettings() {
    const settings = this.getCookie('cfb_timezone_settings')
    return settings ? JSON.parse(settings) : {}
  },

  // Save timezone settings to cookie
  saveTimezoneSettings(settings) {
    this.setCookie('cfb_timezone_settings', JSON.stringify(settings))
  },

  // Get user's selected timezone
  getUserSelectedTimezone() {
    const settings = this.getTimezoneSettings()
    return settings.timezone || null
  },

  // Set user's selected timezone
  setUserSelectedTimezone(timezone) {
    const settings = this.getTimezoneSettings()
    settings.timezone = timezone
    this.saveTimezoneSettings(settings)
  },

  // Get user's preferred 12-hour format setting
  getUse12HourFormat() {
    const settings = this.getTimezoneSettings()
    return settings.use12HourFormat !== undefined ? settings.use12HourFormat : true
  },

  // Set user's preferred 12-hour format setting
  setUse12HourFormat(use12Hour) {
    const settings = this.getTimezoneSettings()
    settings.use12HourFormat = use12Hour
    this.saveTimezoneSettings(settings)
  }
}